import Axios from 'axios';
import { mutationWithAuth } from '../api/graphql-helpers';
import { GENERATE_PRESIGNED_URL } from '../api/graphql/misc';

const getPreSignedUrlForUpload = async ({
  fileKey,
  fileType,
  getAccessToken,
}: {
  fileKey: string;
  fileType: string;
  getAccessToken: () => Promise<string | null>;
}) => {
  const response = await mutationWithAuth<{ generatePresignedUrl: { url: string } }>(
    GENERATE_PRESIGNED_URL,
    {
      input: {
        fileKey,
        fileType,
      },
    },
    getAccessToken,
    true, // Requires authentication
  );
  return response.generatePresignedUrl.url;
};

export const uploadFileToS3ViaPreSignedUrl = async ({
  file,
  keyPrefix,
  getAccessToken,
}: {
  file: File;
  keyPrefix: string;
  getAccessToken: () => Promise<string | null>;
}): Promise<string> => {
  const preSignedUrl = await getPreSignedUrlForUpload({
    fileKey: `${keyPrefix}/${file.name}`,
    fileType: file.type,
    getAccessToken,
  });
  if (!preSignedUrl) throw Error('Could not get a presigned url to upload the file to');

  await Axios.put(preSignedUrl, file);
  return preSignedUrl.split('?')[0];
};
